var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7109 21V19C22.7109 17.1362 21.4362 15.5701 19.7109 15.126M16.2109 3.29076C17.6769 3.88415 18.7109 5.32131 18.7109 7C18.7109 8.67869 17.6769 10.1159 16.2109 10.7092M17.7109 21C17.7109 19.1362 17.7109 18.2044 17.4065 17.4693C17.0005 16.4892 16.2218 15.7105 15.2417 15.3045C14.5066 15 13.5747 15 11.7109 15H8.71094C6.84717 15 5.91529 15 5.1802 15.3045C4.20009 15.7105 3.4214 16.4892 3.01542 17.4693C2.71094 18.2044 2.71094 19.1362 2.71094 21M14.2109 7C14.2109 9.20914 12.4201 11 10.2109 11C8.0018 11 6.21094 9.20914 6.21094 7C6.21094 4.79086 8.0018 3 10.2109 3C12.4201 3 14.2109 4.79086 14.2109 7Z",
    stroke: "#101828",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers01);
export default __webpack_public_path__ + "static/media/users-01.dce284a638e91bdf89951a19b902c4bb.svg";
export { ForwardRef as ReactComponent };